import Image from 'app/Components/Shared/Image/image';
import React from 'react';
import './OneBannerCentered.scss';

const OneBannerCentered = ({data, context}) => {
  const handleButtonClick = (link) => {
    if (link) {
      console.log('Navigating to:', link);
      context.navigateTo(link);
    }
  };

  return (
    <div className="one-banner-centered">
      <div className="one-banner-centered-content">
        <div className="one-banner-centered-color-layer" style={{ backgroundColor: data.mainBackgroundColor }}></div>
        <div className="one-banner-centered-text-bg">
          <div className="one-banner-centered-container-bg">

          </div>
          <div className="one-banner-centered-text-buttons">
            <div className="one-banner-centered-main-text">
              <div className="one-banner-centered-main-text-title" style={{ color: data.mainTextColor || '#FFFFFF' }} dangerouslySetInnerHTML={{__html: data.mainText}} />
              {data.additionalText && (
                <div className="one-banner-centered-additional-text" style={{ color: data.additionalTextColor || '#FFFFFF' }} dangerouslySetInnerHTML={{__html: data.additionalText}} />
              )}
              {data.secondaryText && (
                <div className="one-banner-centered-secondary-text" style={{ color: data.secondaryTextColor || '#FFFFFF' }} dangerouslySetInnerHTML={{__html: data.secondaryText}} />
              )}
            </div>
            <div className={`one-banner-centered-buttons ${(data.mainButton?.text && data.mainButton?.link && data.secondaryButton?.text && data.secondaryButton?.link) ? 'one-banner-centered-buttons--two-buttons' : ''}`}>
              {data.mainButton?.text && data.mainButton?.link && (
                <button
                  className={`one-banner-centered-button-text banner-button banner-button--${data.mainButton.style}`}
                  onClick={() => handleButtonClick(data.mainButton.link)}>
                  <span>{data.mainButton.text}</span>
                </button>
              )}
              {data.secondaryButton?.text && data.secondaryButton?.link && (
                <button
                  className={`one-banner-centered-button-text banner-button-secondary banner-button-secondary--${data.secondaryButton.style}`}
                  onClick={() => handleButtonClick(data.secondaryButton.link)}>
                  {data.secondaryButton.text}
                </button>
              )}
            </div>
          </div>
        </div>
        <div className="one-banner-centered-image">
          {data.mainBackground && data.mainBackgroundType === 'video' && (
            <video autoPlay loop muted playsInline>
              <source src={data.mainBackground} type="video/mp4" />
            </video>
          )}
          {data.mainBackground && (data.mainBackgroundType === 'image' || data.mainBackgroundType === 'gif') && (
            <Image src={data.mainBackground} alt="Banner" />
          )}
        </div>
      </div>
    </div>
  );
};

export default OneBannerCentered;
